import React from 'react'

import Spinner from './Spinner'

import '../../css/common/KeyList.css'

type TBodyProps = {
  isLoading: boolean
  TRow: () => JSX.Element
  colSpan: string
}

const TBody = ({ isLoading, colSpan, TRow }: TBodyProps) => (
  <tbody>{isLoading ? <SpinnerTag colSpan={colSpan} /> : <TRow />}</tbody>
)

const SpinnerTag = ({ colSpan }) => (
  <>
    <tr>
      <td colSpan={colSpan}>
        <Spinner />
      </td>
    </tr>
  </>
)

export default TBody
